import { Component } from '@angular/core'
import { NbLoginComponent } from '@nebular/auth'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class LoginComponent extends NbLoginComponent {
    googleLink = environment.googleLoginUrl
    facebookLink = environment.facebookLoginUrl
    appleLink = environment.appleLoginUrl
}
